<template>
  <div class="expander">
    <slot name="header" v-bind:options="options"></slot>
    <div
      class="main-content"
      style="display:none"
      v-animate-css="'fadeIn'"
      v-show="options.expanded"
    >
      <slot name="main" v-bind:options="options"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "expander",
  components: {},
  props: ["expand"],
  data: () => {
    return {
      options: {
        expanded: false
      }
    };
  },
  mounted() {
    let vm = this;
    vm.options.expanded = vm.expand;
  },
  methods: {}
};
</script>
<style lang="scss" scoped></style>
